(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag", "mbc-legend"], factory);
	else if(typeof exports === 'object')
		exports["mbc-line"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else
		root["mbc-line"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 122);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(103);

var _lineChart = __webpack_require__(70);

var _lineChart2 = _interopRequireDefault(_lineChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _lineChart2.default;

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(0);
var TooltipPlugin = __webpack_require__(1);
var Utils = core.Utils;

function Tooltip() {}

Tooltip.defaultTemplate = "<div class=\"tooltip-inner tooltip-flag\">\n                            <div class=\"tooltip-title\"><p><%this.datapoint%></p></div>\n                            <div class=\"tooltip-body tooltip-table\">\n                                <%for(var index in this.data){%>\n                                    <%if (this.data.hasOwnProperty(index)) {%>\n                                        <div class=\"cell tooltip-row\">\n                                            <div class=\"tip-cell-icon tooltip-cell\"\n                                                <%if(this.data[index].showDots){%>class=\"benchmark\"<%} %>\n                                                style=\"<%if(this.data[index].showDots){%> border-top: 2px dotted <%this.data[index].color %>; <%} %>\n                                                <%if(!this.data[index].showDots){%> background-color: <% this.data[index].color %> <%} else {%> background-color: transparent <%} %>\n                                                \">\n                                            </div>\n                                            <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: <%this.maxWidthTextCell%>px\"><%this.data[index].name%></div>\n                                            <div class=\"tip-cell-data tooltip-cell\"><%this.data[index].value%></div>\n                                        </div>\n                                    <%}%>\n                                <%}%>\n                            </div>\n                        </div>";

/**
 * @method resetZones
 * @desc Clear all the tooltip zones
 * @return undefined
 */
Tooltip.prototype.resetZones = function () {
    var canvas = this.get("canvas");
    var layer = canvas.layer("mbc-line-chart-tooltip", "front");
    layer.selectAll("rect").remove();
};

/**
 * Fill all data into the current tooltip template.
 */

Tooltip.prototype.compileTemplate = function (d) {
    var context = Utils.assign({}, this.__attributes);

    var datapoint = Utils.string.unmask(d);
    if (this.get("xAxisDateLabel")) {
        var format = this.get("tooltipTimeFormat") || d3.time.format("%x");
        datapoint = format(new Date(datapoint));
    }
    context.datapoint = datapoint;

    var _this = this;
    var tooltipData = this.get("dataForTooltips");
    var dataMan = this.get("data");
    var y1DS = this.get("lineDataSourceY1");
    var index = d.split('$$').slice(0, 1);
    var seriesData = [];
    tooltipData.forEach(function (line, idx) {
        var formatFn = dataMan.inGroup(line.groupName, y1DS) ? _this.tickFormat(_this.get("y1TickFormat")) : _this.tickFormat(_this.get("y2TickFormat"));
        var formattedValue = formatFn(line.series[index]);
        var value = formattedValue == null || formattedValue == "" ? "N/A" : formattedValue;
        var showDots = _this.isDottedLine(line.groupName, line.displayName);
        seriesData.push({
            name: line.displayName,
            groupName: line.groupName,
            showDots: showDots,
            value: value,
            color: _this.color(idx)
        });
    });
    context.data = seriesData;

    var longestValue = Utils.string.getLongestTextStringWidth(context.data);
    context.maxWidthTextCell = 164 - longestValue; // 200 max width - 10 icon with - 26 in total padding

    var template = this.get("tooltipTemplate");
    return Utils.string.template(template, context);
};

/**
 * Create a new Tooltip Plugin object and it is binded to the chart hovering zones.
 */

Tooltip.prototype.addTooltip = function () {
    var canvas = this.get("canvas");
    var tooltipCanvas = canvas.layer("mbc-line-chart-tooltip", "front");
    var selection = canvas.layer("mbc-line-chart-tooltip", "front").selectAll(".mbc-line-chart-tooltip-zone");
    var template = this.get("tooltipTemplate");

    if (template) {
        var tooltip = TooltipPlugin({
            position: "top-right",
            namespace: this.get("id"),
            autoposition: canvas,
            chart: "line",
            flagZoneWidth: this.get("flagZoneBarWidth"),
            canvasWidth: canvas.width()

        }).template(this.compileTemplate.bind(this));
        selection.call(tooltip.bind());
        this.set("tooltipObject", tooltip);
    }
};

/**
 * Initializes the tooltip.
 */
Tooltip.prototype.initTooltip = function () {
    this.resetZones();
    this.addTooltipZones();
    this.addTooltip();
};

/**
 * Adds the mouse hover zones to trigger the tooltip.
 */
Tooltip.prototype.addTooltipZones = function () {
    var canvas = this.get("canvas");
    var data = this.get("xDomain");

    var scales = this.get("scales");
    var xScale = scales.scale("x");
    var rangeBand = Math.round(xScale.rangeBand());

    var x = function x(d, i) {
        return xScale(xScale.domain()[i]);
    };

    rangeBand = rangeBand - rangeBand % 2;
    canvas.removeLayer("mbc-line-chart-tooltip", "front");
    var layer = canvas.layer("mbc-line-chart-tooltip", "front");

    var zones = layer.selectAll(".mbc-line-chart-tooltip-zone").data(data);
    this.set("flagZoneBarWidth", rangeBand);
    // Enter
    var _this = this;
    zones.enter().append("rect").classed("mbc-line-chart-tooltip-zone", true).attrs({
        opacity: 0,
        width: rangeBand,
        height: canvas.height(),
        x: x,
        y: 0
    }).on("mouseleave", function (d, i) {
        var line = layer.selectAll(".mouse-line")[0][i];
        line.style.opacity = 0;

        // hide bubble if it's should be hidden
        if (!_this.get("agileStyle").dotOpacity) {
            _this.get("data")._data.forEach(function (line, index) {
                var lineDot = canvas.layer("layer-dots" + index).selectAll(".lineDot")[0][i];
                lineDot.style.opacity = 0;
            });
        }
    }).on("mouseover", function (d, i) {
        if (_this.get("showVerticalLine")) {
            var line = layer.selectAll(".mouse-line")[0][i];
            line.style.opacity = 1;
        }

        // display bubbles if it's hidden
        if (!_this.get("agileStyle").dotOpacity) {
            _this.get("data")._data.forEach(function (line, index) {
                var lineDot = canvas.layer("layer-dots" + index).selectAll(".lineDot")[0][i];
                lineDot.style.opacity = 1;
            });
        }
    });

    this.drawMouseLine();
};

module.exports = Tooltip;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Legend = __webpack_require__(2);
var Tooltip = __webpack_require__(69);
var namespace = "mbc-line-chart";

var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;
var DateAxis = Core.Axes.DateAxis;
var mds_constants = Utils.colors.mds_constants;
var mds_chart_color = Utils.colors.mds_chart_color;

/**
 * Line Chart.
 *
 * @example
 * // Extension example:
 * var LineChart = require("mbc-line");
 *
 * var NewExtendedLineChart = LineChart.extend({
 *   ...
 * });
 *
 * @example
 * // Use example:
 * var LineChart = require("mbc-line");
 *
 * var chart = new LineChart(<options>);
 * d3Container.datum(data).call(Lchart.init());
 *
 * @class
 * @extends Chart
 */
var LineChart = Chart.extend(Legend, Tooltip,
/**
 * @lends LineChart.prototype
 **/
{
    /** @type {String} */
    id: namespace, // Also used as class for this chart type.
    /** @type {Number} */
    screenMinHeight: 100, // container min-height
    /** @type {String} */
    linesColor: mds_chart_color["1"],
    /** @type {String} */
    lineDataSourceY1: "y1AxisData",
    /** @type {String} */
    lineDataSourceY2: "y2AxisData",
    /** @type {Number} */
    breakpoint: 600,
    /** @type {Boolean} */
    legend: true,
    /** @type {Number} */
    legendMaxWidth: 120,
    /** @type {String} */
    legendPosition: "right",
    /** @type {Number} */
    ticksNumber: 4,
    /** @type {Boolean} */
    ticksSymmetrical: true,
    /** @type {Array} */
    tickValues: null,
    /** @type {String} */
    xAxisOrient: "bottom",
    /** @type {Array} */
    xAxisLabels: null,
    /** @type {String} */
    xAxisLabelsDatasource: "xLabels",
    /** @type {Array} */
    xDomain: null,
    /** @type {String} */
    xDomainDatasource: "xDomain",
    /** @type {String} */
    y1Abbreviation: null,
    /** @type {Boolean|String} */
    y1AxisLabel: false,
    /** @type {String} */
    y1AxisOrient: "left",
    /** @type {String} */
    y1DataSource: "y1AxisData",
    /** @type {String} */
    y1TicksAlign: "right",
    /** @type {Function|String} */
    y1TickFormat: ",.2f",
    /** @type {String} */
    y1TickSymbol: "$",
    /** @type {Boolean} */
    y2: true,
    /** @type {String} */
    y2Abbreviation: null,
    /** @type {Boolean} */
    y2AxisLabel: false,
    /** @type {String} */
    y2AxisOrient: "left",
    /** @type {String} */
    y2DataSource: "y2AxisData",
    /** @type {String} */
    y2TicksAlign: "right",
    /** @type {Function|String} */
    y2TickFormat: ",.2f",
    /** @type {String} */
    y2TickSymbol: "$",
    /** @type {Number} */
    yAxesLabelWidth: 15,
    /** @type {Number} */
    yAxesLabelPadding: 3,
    /** @type {Number} */
    yAxesSpacing: 12,
    /** @type {Object} */
    domainRounding: {
        y1: null, // takes a number to set as the rounding value (e.g., 10)
        y2: null
    },
    /** @type {Array} */
    yDomain: null,
    /** @type {Array} */
    y2Domain: null,
    /** @type {Number} */
    yPadding: 12,
    /** @type {Number} */
    yPaddingBig: 12,
    /** @type {Number} */
    yPaddingSmall: 6,
    /** @type {Number} */
    yTickMargin: 6,
    /** @type {Number} */
    yTickSize: 35,
    /** @type {Boolean} */
    tooltip: true,
    /** @type {String} */
    tooltipTemplate: Tooltip.defaultTemplate,
    /** @type {Number} */
    dotHeight: 2,
    /** @type {Object} */
    dottedLineNames: {
        y1AxisData: true, // true|false|Array: ["line1Name", "line2Name", ...]
        y2AxisData: false // true|false|Array: ["line1Name", "line2Name", ...]
    },
    /** @type {Number} */
    lineStrokeWidth: 2,
    /** @type {String} */
    dottedDashDimensions: "1, 5",
    /** @type {Number} */
    dotRadius: 4,
    /** @type {Number} */
    dotStrokeWidth: 2,
    /** @type {Number} */
    y1TickWidth: 0, //config axis-y1 width, if not passing this value, chart will calculate  appropriate width.
    /** @type {Boolean} */
    showZeroLine: true, //Control grid zero line opacity
    /** @type {Boolean} */
    showGrayBands: true,
    /** @type {String} */
    grayBand: mds_constants["background-color"].light,
    /** @type {Boolean} */
    showVerticalLine: true,
    /** @type {Boolean} **/
    xAxisDateLabel: false,
    /** @type {String} **/
    timeLevel: 'monthly',
    /** @type {Function|Null} */
    tooltipTimeFormat: d3.time.format("%x"),
    /**
     * @override
     * Prepare the data for the chart.
     * @param {Object} data Raw data.
     */
    setData: function setData(data) {
        var linesSourceY1 = this.get("lineDataSourceY1");
        var linesSourceY2 = this.get("lineDataSourceY2");
        var linesDataY1 = Utils.object.path(data, linesSourceY1);
        var linesDataY2 = Utils.object.path(data, linesSourceY2);
        var xAxisLabels = Utils.object.path(data, this.get("xAxisLabelsDatasource"));
        var _this = this;

        this.set("xDomain", Utils.object.path(data, this.get("xDomainDatasource")).map(function (d, i) {
            return Utils.string.mask(d, i);
        }));

        if (!Utils.array.hasNulls(xAxisLabels)) {
            this.set("xAxisLabels", xAxisLabels);
        }

        if (linesDataY1) {
            linesDataY1.forEach(function (line) {
                _this.get("data").uset({
                    name: linesSourceY1,
                    series: line.values,
                    display: line.name,
                    color: line.color
                });
            });
        } else {
            console.warn("ERROR ==> No data provided for rendering lines");
        }

        if (linesDataY2) {
            linesDataY2.forEach(function (line) {
                _this.get("data").uset({
                    name: linesSourceY2,
                    series: line.values,
                    display: line.name,
                    color: line.color
                });
            });
        }
    },

    /**
     * @override
     */
    beforeDraw: function beforeDraw() {

        this.redoCanvas();
        if (this.get('clipPathId') == null) {
            var id = Math.floor(Math.random() * 90000) + 10000;
            this.set("clipPathId", namespace + "-clip-mask--" + id);
        }
        var dataManager = this.get("data");
        var canvas = this.get("canvas");
        var tickValues = this.get("tickValues");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var domain;
        var rounding = this.get("domainRounding");

        if (!y1LabelText && !y2LabelText) {
            canvas.set("yAxesLabelWidth", 0);
        } else {
            canvas.set("yAxesLabelWidth", yAxesLabelWidth);
        }

        canvas.set("tickSize", this.get("yTickSize"));
        canvas.set("axesSpacing", this.get("yAxesSpacing"));
        canvas.set("axesPadding", this.get("yPadding"));
        canvas.set("margin", this.getMargins());

        if (tickValues && tickValues.length > 1) {
            this.set("_yDomain", [tickValues[0], tickValues[tickValues.length - 1]]);
        } else {
            domain = dataManager.calculateDomain({
                groups: [this.get("y1DataSource"), this.get("lineDataSourceY1")],
                symmetrical: this.get("ticksSymmetrical"),
                steps: this.get("ticksNumber"),
                roundTo: rounding.y1
            });
            this.set("_yDomain", domain);
        }

        if (this.get("y2")) {
            if (tickValues && tickValues.length > 1) {
                this.set("_y2Domain", [tickValues[0], tickValues[tickValues.length - 1]]);
            } else {
                domain = dataManager.calculateDomain({
                    groups: [this.get("y2DataSource"), this.get("lineDataSourceY2")],
                    symmetrical: this.get("ticksSymmetrical"),
                    steps: this.get("ticksNumber"),
                    roundTo: rounding.y2
                });
                this.set("_y2Domain", domain);
            }
        } else {
            this.get("axes").remove("y2");
        }

        if (canvas.get("outerWidth") <= this.get("breakpoint")) {
            this.set("yPadding", this.get("yPaddingSmall"));
        } else {
            this.set("yPadding", this.get("yPaddingBig"));
        }
    },

    /**
     * @override
     */
    draw: function draw() {
        if (this.get("legend")) {
            this.invokeLegend({
                chart: 'lineChart',
                data: this.get("data")._data
            });
            this.get("canvas").update();
        }

        if (this.get("xAxisDateLabel")) {
            var dateAxis = new DateAxis({
                domain: this.get('xDomain'),
                range: [0, this.get("canvas").width()],
                timeLevel: this.get('timeLevel'),
                orient: this.get('xAxisOrient')
            });

            this.set('dateAxis', dateAxis);
            this.set('xAxisLabels', dateAxis.get('subLabels'));
        }

        this.buildScales();
        this.drawBars();
        this.buildAxes();
        this.drawAxes();
        this.drawGrid();
        this.drawClipPath();

        if (this.get("tooltip")) {
            this.initTooltip();
        }
    },

    /**
     * To draw a vertical line on mouse over for each x-axis bar zone
     */
    drawMouseLine: function drawMouseLine() {
        var canvas = this.get("canvas");
        var layer = canvas.layer(namespace + "-tooltip", "front");
        var scales = this.get("scales");
        var xDomainLabels = this.get("xDomain");
        var lines = layer.selectAll(".hover-bar-lines").data(xDomainLabels);
        var xScale = scales.scale("x");

        xScale.rangeBands([0, canvas.width()], 0);
        var width = xScale.rangeBand();

        lines.enter().append("line").attrs({
            x1: function x1(d) {
                return xScale(d) + width / 2;
            },
            x2: function x2(d) {
                return xScale(d) + width / 2;
            },
            y1: 0,
            y2: canvas.height(),
            class: "mouse-line",
            stroke: "black",
            "stroke-width": "1px",
            "stroke-dasharray": "3,3",
            opacity: 0,
            "pointer-events": "all"
        });

        lines.exit().remove();
    },

    /**
     * @override
     */
    afterDraw: function afterDraw(options) {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var noTicksRecalc = options && options.noTicksRecalc;
        var domain, first, last, height;

        this.adjustYLabels();

        if (!this.get("xAxisDateLabel") && canvas.get("outerWidth") <= this.get("breakpoint")) {
            axes.selectAll("." + Classes.AXIS + "-x text").style("display", "none");
            domain = this.get("xDomain");
            first = Utils.string.unmask(domain[0]);
            last = Utils.string.unmask(domain[domain.length - 1]);
            height = canvas.height() + 15;
            axes.append("text").attrs({
                x: 5,
                y: height,
                class: "x-alternative-first",
                "text-anchor": "start"
            }).text(first);
            axes.append("text").attrs({
                x: canvas.width() - 6,
                y: height,
                class: "x-alternative-last",
                "text-anchor": "end"
            }).text(last);
        }

        if (this.get("legend")) {
            canvas.watch("outerWidth", function (newValue, oldValue) {
                this.checkBreakpoints(newValue, oldValue);
            }.bind(this));
        }

        if (!noTicksRecalc) {
            this.updateTickWidths(axes);
        }
    },

    /**
     * This method is intended for Y axes tick width recalculation.
     */
    updateTickWidths: function updateTickWidths(axes) {
        var maxWidth = 0;
        var ticks = [];
        var y1TickWidth = this.get("y1TickWidth");
        var el;

        if (y1TickWidth) {
            this.set("yTickSize", y1TickWidth);
        } else {
            d3.selectAll(".mbc-axis.mbc-axis-y1 .tick text").each(function () {
                el = d3.select(this);
                ticks.push(el.text());
            });

            maxWidth = Utils.svg.getGreaterSVGTextWidth(axes.select("." + Classes.AXIS + "-x"), ticks);
            this.set("yTickSize", maxWidth + this.get("yTickMargin"));
        }

        this.set("ticksUpdated", true);
        this.update({ noTicksRecalc: true });
    },

    /**
     * @method drawClipPath
     * @desc Chart svg includes clipping layer, clips lines and bubbles at edge of chart area
     * @example
     *
     * chart.drawClipPath()
     *
     * @return undefined
     */
    drawClipPath: function drawClipPath() {
        var canvas = this.get("canvas");
        var svg = canvas.get("svg");
        var layer = svg.select("." + Classes.BACK);
        var layerBBox = layer.node().getBBox();

        svg.insert("defs", ":first-child").append("clipPath").attr("id", this.get('clipPathId')).append("rect").attr({
            x: layerBBox.x,
            y: layerBBox.y,
            width: layerBBox.width,
            height: layerBBox.height
        });
    },

    /**
     * Get the data and call for draw stacked or gruped bar chart as stated in 'stacked' attribute.
     */
    drawBars: function drawBars() {
        var data = this.get("data")._data;
        var xDomainLabels = this.get("xDomain");
        var canvas = this.get("canvas");
        var scales = this.get("scales");
        var layer = canvas.layer("background-bar-group", "back");
        var bars = layer.selectAll(".bar-group").data(xDomainLabels);
        var xScale = scales.scale("x");
        var showGrayBands = this.get("showGrayBands");
        var _this = this;

        var _fill = function _fill(index) {
            if (showGrayBands) {
                return index % 2 === 0 ? _this.get("grayBand") : "#ffffff";
            }
            return "#ffffff";
        };

        xScale.rangeBands([0, canvas.width()], 0);

        bars.enter().append("rect").classed(".bar-group", true).attr({
            width: xScale.rangeBand(),
            x: function x(d) {
                return xScale(d);
            },
            y: 0,
            height: canvas.height(),
            opacity: 1,
            fill: function fill(d, i) {
                return _fill(i);
            }
        });

        bars.attr({
            width: xScale.rangeBand(),
            x: function x(d) {
                return xScale(d);
            },
            y: 0,
            height: canvas.height(),
            opacity: 1,
            fill: function fill(d, i) {
                return _fill(i);
            }
        });

        bars.exit().remove();

        this.set("dataForTooltips", data);
        this.drawLines(data);
    },

    drawLines: function drawLines(linesData) {
        this.calculateAgileStyle();
        var _this = this;
        linesData.forEach(function (line, index) {
            _this.drawLine(line, index);
            _this.drawDots(line, index);
        });
    },

    isDottedLine: function isDottedLine(group, name) {
        var dottedLineNames = this.get("dottedLineNames")[group];
        if (dottedLineNames instanceof Array) {
            return dottedLineNames.indexOf(name) > -1;
        } else {
            return dottedLineNames;
        }
    },

    drawLine: function drawLine(data, index) {
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var y2Scale = scales.scale("y2");
        var layer = this.get("canvas").layer("layer-lines" + index).attr("clip-path", "url(#" + this.get('clipPathId') + ")");
        var group = data.groupName;
        var isDotted = this.isDottedLine(group, data.displayName);
        var color = data.color || this.color(index);
        var agileStyle = this.get("agileStyle");
        var xDomainLabels = this.get("xDomain");

        var xoffset = xScale.rangeBand() / 2;

        var generateLine = d3.svg.line().defined(function (d) {
            return d != null;
        }).x(function (d, i) {
            return xScale(xScale.domain()[i]) + xoffset;
        }).y(function (d) {
            return yScale(d);
        }).interpolate("linear");

        var generateY2Line = d3.svg.line().defined(function (d) {
            return d != null;
        }).x(function (d, i) {
            return xScale(xScale.domain()[i]) + xoffset;
        }).y(function (d) {
            return y2Scale(d);
        }).interpolate("linear");

        var lines = layer.selectAll(".line").data(xDomainLabels);
        var series = data.series;
        var linePath = group === "y2AxisData" ? generateY2Line(series) : generateLine(series);
        lines.enter().append("path").classed("line", true).attrs({
            d: linePath,
            stroke: color,
            fill: "none",
            "shape-rendering": "auto",
            "stroke-dasharray": function strokeDasharray() {
                return isDotted ? agileStyle.dottedDashDimensions : null;
            },
            "stroke-linecap": function strokeLinecap() {
                return isDotted ? "round" : null;
            },
            "stroke-width": function strokeWidth() {
                return isDotted ? agileStyle.lineStrokeWidth : null;
            }
        });
        lines.exit().remove();
    },

    drawDots: function drawDots(data, index) {
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var y2Scale = scales.scale("y2");
        var layer = this.get("canvas").layer("layer-dots" + index).attr("clip-path", "url(#" + this.get('clipPathId') + ")");
        var color = data.color || this.color(index);
        var xoffset = xScale.rangeBand() / 2;
        var group = data.groupName;
        var isDotted = this.isDottedLine(group, data.displayName);
        var lineDots = layer.selectAll(".lineDot").data(data.series);
        var style = this.get("agileStyle");

        lineDots.enter().append("circle").classed("lineDot", true).attrs({
            cx: function cx(d, i) {
                return xScale(xScale.domain()[i]) + xoffset;
            },
            cy: function cy(d) {
                if (d == null) {
                    d = 0;
                }
                if (group === "y1AxisData") {
                    return yScale(d);
                } else if (group === "y2AxisData") {
                    return y2Scale(d);
                }
            },
            r: function r(d) {
                if (d == null) {
                    return 0;
                }
                return style.dotRadius;
            },
            "stroke-width": style.dotStrokeWidth,
            stroke: color,
            "shape-rendering": "auto",
            fill: function fill() {
                return isDotted ? "#ffffff" : color;
            },
            opacity: function opacity(d) {
                if (d == null || !style.dotOpacity) {
                    return 0;
                }
            }
        });

        lineDots.exit().remove();
    },

    /**
    * @method calculateAgileStyle
    * @desc Calculate agile style for chart based on container size
    * @return {Object} the agile style for chart.
    */
    calculateAgileStyle: function calculateAgileStyle() {
        var canvas = this.get("canvas");
        var xScale = this.get("scales").scale("x");
        xScale.rangeBands([0, canvas.width()], 0);
        var grayBandWidth = xScale.rangeBand();

        var dotRadius = this.get("dotRadius"); // default: 4
        var dotStrokeWidth = this.get("dotStrokeWidth"); // default: 2
        var lineStrokeWidth = this.get("lineStrokeWidth"); // default: 2
        var dottedDashDimensions = this.get("dottedDashDimensions"); // default: "1, 5"

        var showBigDotMinWidth = 2 * (dotRadius + 4); // 4px: dot marging
        var showSmallDotMinWidth = 2 * (dotRadius / 2 + 2); // 2px: dot marging

        var agileStyle;
        if (grayBandWidth >= showBigDotMinWidth) {
            agileStyle = {
                lineStrokeWidth: lineStrokeWidth,
                dottedDashDimensions: dottedDashDimensions,
                dotStrokeWidth: dotStrokeWidth,
                dotRadius: dotRadius,
                dotHeight: dotStrokeWidth + dotRadius,
                dotOpacity: 1
            };
        } else if (grayBandWidth >= showSmallDotMinWidth) {
            agileStyle = {
                lineStrokeWidth: lineStrokeWidth / 2,
                dottedDashDimensions: "1, 3",
                dotStrokeWidth: dotStrokeWidth / 2,
                dotRadius: dotRadius / 2,
                dotHeight: (dotStrokeWidth + dotRadius) / 2,
                dotOpacity: 1
            };
        } else {
            agileStyle = {
                lineStrokeWidth: lineStrokeWidth / 2,
                dottedDashDimensions: "1, 3",
                dotStrokeWidth: dotStrokeWidth / 2,
                dotRadius: dotRadius / 2,
                dotHeight: (dotStrokeWidth + dotRadius) / 2,
                dotOpacity: 0
            };
        }
        this.set("agileStyle", agileStyle);
        return agileStyle;
    },

    /**
     * Draws the axes into the canvas and its labels.
     */
    drawAxes: function drawAxes() {
        var axes = this.get("axes");
        var canvas = this.get("canvas");

        canvas.drawAxes(axes);

        this.drawAxesLabels();
    },

    /**
     * Appends labels for Y axes and also appends the X axes sub labels.
     */
    drawAxesLabels: function drawAxesLabels() {
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        canvas.layer(Classes.AXES + "-labels", "axes").remove();
        canvas.layer(Classes.AXES + "-xlabels", "axes").remove();
        var layer = canvas.layer(Classes.AXES + "-labels", "axes");
        var xlayer = canvas.layer(Classes.AXES + "-xlabels", "axes");
        var xScale = this.get("scales").scale("x");
        var xAxisOrient = this.get("xAxisOrient");
        var xLabels = this.get("xAxisLabels");
        var xTexts;

        if (y1LabelText) {
            this.appendYLabel(layer, "y1", y1LabelText);
        }

        if (this.get("y2") && y2LabelText) {
            this.appendYLabel(layer, "y2", y2LabelText);
        }

        var isDateXAxis = this.get('xAxisDateLabel');
        // X sub labels
        if (!isDateXAxis && canvas.get("outerWidth") > this.get("breakpoint") && xLabels) {
            xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
            xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
                var x = xScale(d) + xScale.rangeBand() / 2;
                var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
                return "translate(" + x + ", " + y + ")";
            }).append("text").text(function (d, i) {
                var label = "";
                if (i < xLabels.length) {
                    label = xLabels[i] || "";
                }

                return label;
            }).attrs({
                "text-anchor": "middle"
            });
        }

        if (isDateXAxis) {
            this.get("dateAxis").drawSubLabels(canvas);
        }
    },

    /**
     * This method draws the backgroud grid in the chart.
     */
    drawGrid: function drawGrid() {
        var scales = this.get("scales");
        var y1Scale = scales.scale("y1");
        var y1Axis = this.get("axes").axis("y1");
        var canvas = this.get("canvas");
        var tickValues = y1Axis.tickValues();
        var backGroup = canvas.get("backGroup");
        var grid = backGroup.selectAll("." + Classes.GRID_LINE).data(tickValues);
        var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");
        var width = canvas.get("width");

        var extractor = function extractor(d) {
            return y1Scale(d);
        };
        var showZeroLine = this.get("showZeroLine");

        grid.enter().append("line").attrs({
            x1: 0,
            x2: width,
            y1: extractor,
            y2: extractor,
            class: function _class(d, i) {
                var appendClass = "";
                if (i === 0) {
                    appendClass = "first";
                }
                if (i === tickValues.length - 1) {
                    appendClass = "last";
                }
                return Classes.GRID_LINE + " " + appendClass;
            },

            opacity: function opacity(d, i) {
                if (isSmallHeight) {
                    // if container's height is small, only show last grid line
                    return i !== tickValues.length - 1 ? 0 : 1;
                } else {
                    return !showZeroLine && d === 0 && i !== 0 && i !== tickValues.length - 1 ? 0 : 1;
                }
            }
        });

        grid.attrs({
            x1: 0,
            x2: width,
            y1: extractor,
            y2: extractor,
            opacity: function opacity(d, i) {
                if (isSmallHeight) {
                    // if container's height is small, only show last grid line
                    return i !== tickValues.length - 1 ? 0 : 1;
                } else {
                    return !showZeroLine && d === 0 && i !== 0 && i !== tickValues.length - 1 ? 0 : 1;
                }
            }
        });

        grid.exit().remove();
    },

    /**
     * Configure all axes used in the chart.
     */
    buildAxes: function buildAxes() {
        var _this = this;
        var scales = this.get("scales");
        var axes = this.get("axes");
        var calculatedTicks = Utils.chart.getTickValues(this.get("_yDomain"), this.get("ticksNumber"));
        var tickValues = this.get("tickValues") || calculatedTicks;
        var tickValues2, y2axis;

        var tickFormat = function tickFormat(symbol, length, formatFn) {
            return function (d, i) {
                var value = _this.tickFormat(formatFn)(d);
                value = Utils.string.convertDashToEnDash(value);
                return symbol && i === length - 1 ? symbol + value : value;
            };
        };

        var xAxis = d3.svg.axis().scale(scales.scale("x")).orient(this.get("xAxisOrient")).tickFormat(function (d) {
            return Utils.string.unmask(d);
        });

        if (this.get('xAxisDateLabel')) {
            xAxis = this.get('dateAxis').getAxis();
        }

        var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(tickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), tickValues.length, this.get("y1TickFormat")));

        yAxis.axisLabel = this.get("y1AxisLabel");
        axes.axis("x", xAxis);
        axes.axis("y1", yAxis);

        if (this.get("y2")) {
            tickValues2 = Utils.chart.getTickValues(this.get("_y2Domain"));

            y2axis = d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(tickValues2).tickFormat(tickFormat(this.get("y2TickSymbol"), tickValues2.length, this.get("y2TickFormat")));

            axes.axis("y2", y2axis);
        }
    },

    /**
     * Creates the chart scales
     */
    buildScales: function buildScales() {
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var xScale = d3.scale.ordinal().domain(this.get("xDomain")).rangeBands([0, canvas.width()], 0.00);

        if (this.get('xAxisDateLabel')) {
            xScale = this.get('dateAxis').getScale();
        }

        var yScale = d3.scale.linear().domain(this.get("_yDomain")).range([canvas.height(), 0]);

        scales.scale("x", xScale);
        scales.scale("y1", yScale);

        if (this.get("y2")) {
            var y2Scale = d3.scale.linear().domain(this.get("_y2Domain")).range([canvas.height(), 0]);
            scales.scale("y2", y2Scale);
        }
    },

    /**
     * Sets the margin depending on the chart configuration.
     */
    getMargins: function getMargins() {
        var xAxisOrient = this.get("xAxisOrient");
        var xAxisLabels = this.get("xAxisLabels");
        var y1AxisOrient = this.get("y1AxisOrient");
        var y2AxisOrient = this.get("y2AxisOrient");
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
        var yAxesSpacing = this.get("yAxesSpacing");
        var y1AxisLabel = this.get("y1AxisLabel");
        var yPadding = this.get("yPadding");
        var y1Width = !y1AxisLabel ? yTickSize + yPadding : yTickSize + yPadding + yAxesLabelWidth;
        var y2AxisLabel, y2Width;

        var margin = {
            top: xAxisOrient === "top" ? 30 : 5,
            right: y1AxisOrient === "right" ? y1Width + yPadding : yPadding,
            bottom: xAxisOrient === "bottom" ? 25 : 1,
            left: y1AxisOrient === "left" ? y1Width : 0
        };

        if (this.get("y2")) {
            y2AxisLabel = this.get("y1AxisLabel");
            y2Width = !y2AxisLabel ? yTickSize : yTickSize + yAxesLabelWidth;

            if (y1AxisOrient === "left" && y2AxisOrient === "left") {
                margin.left += y2Width + yAxesSpacing;
            } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
                margin.right += y2Width + yAxesSpacing;
            } else {
                margin.right += y2Width + yPadding;
            }
        }

        if (xAxisLabels && xAxisOrient === "top") {
            margin.top += 15;
        } else if (xAxisLabels && xAxisOrient === "bottom") {
            margin.bottom += 15;
        }

        return margin;
    },

    /**
     * Check for responsive breakpoints
     */
    checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
        var dw = newValue > oldValue;
        var breakpoint = this.get("breakpoint");
        if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
            this.redoCanvas();
        }
    },

    /**
     * Sets the canvas template depending on the lengend position.
     */
    setCanvasTemplate: function setCanvasTemplate(width) {
        var template;
        if (this.get("legend")) {
            if (width > this.get("breakpoint")) {
                template = "<div class=\"" + Classes.INNER + " " + Classes.INNER + "-right\"></div>\n                    <div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-right\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>";
            } else {
                template = "<div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-top\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>\n                <div class=\"" + Classes.INNER + " " + Classes.INNER + "-top\"></div>";
            }
        }

        this.set("canvasTemplate", template);
    },

    /**
     * @override
     */
    beforeCanvas: function beforeCanvas(selection) {
        this.setCanvasTemplate(selection[0][0].offsetWidth);
    },

    /**
     * Force the canvas to be created again using the intended template.
     */
    redoCanvas: function redoCanvas() {
        var canvas = this.get("canvas");
        canvas.remove();
        this.setCanvasTemplate();
        this._createCanvas();
    },

    data: function data(dataset) {
        this.get("data").clean();
        this.setData(dataset);
        this.update();
        return this;
    }
});

module.exports = LineChart;

/***/ })

/******/ });
});